import * as yup from "yup";
import {
  emailMustBeValidEmail,
  fieldMaxLength,
  fieldMinLength,
  fieldValuesDoesNotMatch,
  requiredField,
} from "../../../common/infrastructure/helpers/yupHelper";

export const newPasswordFormSchema = yup
  .object({
    email: yup
      .string()
      .email(emailMustBeValidEmail())
      .required()
      .trim()
      .defined(),
    token: yup.string().required().trim().defined(),
    newPassword: yup
      .string()
      .required(requiredField("Парола"))
      .trim()
      .max(200, fieldMaxLength("Парола", 200))
      .min(6, fieldMinLength("Парола", 6))
      .defined(),
    studioId: yup.string().required().trim().max(4).min(1).defined(),
    repeatNewPassword: yup
      .string()
      .oneOf([yup.ref("newPassword")], "Паролите не съвпадат")
      .required(requiredField("Повторение на паролата"))
      .trim()
      .max(200, fieldMaxLength("Повторение на паролата", 200))
      .min(6, fieldMinLength("Повторение на паролата", 6))
      .defined(),
  })
  .required();

export type INewPasswordFormModel = yup.InferType<typeof newPasswordFormSchema>;

export const newPasswordDefaultValues: INewPasswordFormModel = {
  email: "",
  token: "",
  newPassword: "",
  studioId: "",
  repeatNewPassword: "",
};
